<template>
    <Content v-if="showProductPrice(product)">
        <span
            v-if="
                variations.length &&
                    !product.is_linked_products &&
                    !validateProductGroup
            "
        >
            A partir de
        </span>
        <span
            v-if="
                hasPriceTo &&
                    (!variations.length ||
                        (variations.length && product.is_linked_products))
            "
        >
            De
        </span>
        <span v-if="hasPriceTo" class="scratched">
            {{ priceToProduct }}
        </span>
        <span v-if="hasPriceTo">por</span>
        <span class="price-product">
            {{ priceProduct }}
            <small v-if="getShowUnitOfMeasureInProductPrice">
                {{ product.pro_sigla_medida }} ({{ product.med_desc }})
            </small>
            <template v-if="hasAdditionals">+</template>
        </span>
        <br />

        <div class="additional-items" v-if="hasAdditionals">
            <small v-for="(a, key) in additionalItemsSelected.items" :key="key">
                {{ a.abbreviation }} - {{ currency.money(a.price) }}
            </small>
        </div>

        <template v-if="showIpi">
            <small v-if="ipiVariation">+ IPI</small>
            <small v-if="product.ipi_percentage">
                + {{ product.ipi_percentage }}% de IPI
            </small>
        </template>
        <div>
            <DiscountPix />
        </div>
        <div>
            <InterestFreeInstallments :item="product" :product_page="true" />
        </div>

    </Content>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Content } from "./style";
import Currency from "../../../helpers/parseCurrency";
import InterestFreeInstallments from "../InterestFreeInstallments.vue";
import DiscountPix from "../DiscountPix.vue";

export default {
    name: "ProductPrice",
    props: {
        product: {
            required: true
        }
    },
    components: {
        Content,
        InterestFreeInstallments,
        DiscountPix,
    },
    data() {
        return {
            currency: Currency
        };
    },
    methods: {
        getPriceFlavor(price_flavor) {
            return this.product.price_to
                ? price_flavor -
                      price_flavor * (this.product.percentage_discount / 100)
                : price_flavor;
        },
        getDiscountPix() {
            return getDiscountPix(this.company)
        }

    },
    computed: {
        ...mapState("products", [
            "variations",
            "additionalItemsSelected",
            "quantityFractional"
        ]),
        ...mapState("company",[
            "company"
        ]),
        ...mapGetters("products", ["getFlavorsSelected", "showProductPrice"]),
        ...mapGetters("company", [
            "getShowUnitOfMeasureInProductPrice",
            "showIpi"
        ]),
        validateProductGroup() {
            return this.activateSaleProductGroups && this.isProductGroup;
        },
        isProductGroup() {
            return this.productSettings?.is_product_group ?? false;
        },
        productSettings() {
            if (this.product?.settings) {
                return JSON.parse(this.product.settings);
            }
            return null;
        },
        activateSaleProductGroups() {
            return (
                this.$root.$children[0].$attrs.company?.settings
                    ?.activate_sale_product_groups ?? false
            );
        },
        ipiVariation() {
            return (
                this.variations?.some(el => el.ipi_percentage) &&
                !this.product.is_linked_products
            );
        },
        hasAdditionals() {
            return !!this.additionalItemsSelected?.items?.length;
        },
        hasFlavors() {
            return !!this.getFlavorsSelected?.length;
        },
        priceProduct() {
            return this.currency.money(
                this.hasFlavors
                    ? Math.max(
                          ...this.getFlavorsSelected.map(flavor =>
                              this.product.fractional_sale
                                  ? this.getPriceFlavor(
                                        flavor.price *
                                            Number(this.quantityFractional)
                                    )
                                  : this.getPriceFlavor(flavor.price)
                          ),
                          this.product.price_to ?? this.product.pro_price_site
                      )
                    : this.product.price_to ?? this.product.pro_price_site
            );
        },
        priceToProduct() {
            return this.currency.money(
                this.hasFlavors
                    ? Math.max(
                          ...this.getFlavorsSelected.map(flavor =>
                              this.product.fractional_sale
                                  ? flavor.price *
                                    Number(this.quantityFractional)
                                  : flavor.price
                          ),
                          this.product.pro_price_site
                      )
                    : this.product.pro_price_site
            );
        },
        hasPriceTo() {
            return (
                this.product.price_to &&
                Number(this.product.price_to) !=
                    Number(this.product.pro_price_site)
            );
        }
    }
};
</script>
